module.exports = __webpack_public_path__ + "static/media/48_B.e6e7ba9b.png";